<div class="payment-page">

  <header class="payment-header">
    <a class="payment-logo" href="/">
      <span class="logo-pxl">pxl</span><span class="logo-vd">vd</span><span class="logo-dot">.com</span>
    </a>
  </header>

  <div class="payment-wrap">
    <div class="payment-card">

      <!-- ── Polling / loading ── -->
      <ng-container *ngIf="(verifyStatus$ | async) === 'polling' || (verifyStatus$ | async) === 'idle'">
        <div class="payment-icon loading">⏳</div>
        <h1 class="payment-title loading">Confirming…</h1>
        <p class="payment-subtitle">Verifying your payment with our server, just a moment…</p>
      </ng-container>

      <!-- ── Confirmed ── -->
      <ng-container *ngIf="(verifyStatus$ | async) === 'confirmed'">
        <div class="payment-icon success">✓</div>
        <h1 class="payment-title success">You're in!</h1>
        <p class="payment-subtitle">
          Your purchase was successful. Welcome to pxlvd - you now have access to all features and all future updates.
        </p>

        <div class="payment-detail-box" *ngIf="userEmail$ | async as email">
          <div class="payment-detail-row">
            <span class="detail-label">Account</span>
            <span class="detail-value">{{ email }}</span>
          </div>
          <div class="payment-detail-row">
            <span class="detail-label">Status</span>
            <span class="detail-value accent">Active</span>
          </div>
        </div>

        <button class="payment-btn-primary" (click)="goToStudio()">Open Studio →</button>

        <hr class="payment-divider">
        <p class="payment-note">
          A confirmation has been sent to your email. Remember, you have a
          <strong>14-day money-back guarantee</strong> - contact
          <a href="mailto:manoj@pxlvd.com">manoj&#64;pxlvd.com</a> for any issues.
        </p>
      </ng-container>

      <!-- ── Not found (webhook delay) ── -->
      <ng-container *ngIf="(verifyStatus$ | async) === 'not_found'">
        <div class="payment-icon error">⚠</div>
        <h1 class="payment-title error">Still processing…</h1>
        <p class="payment-subtitle">
          We couldn't confirm your payment yet - it may take a moment to finalise.
          Please refresh in a minute. If the issue persists, contact support.
        </p>
        <div class="payment-actions">
          <button class="payment-btn-primary" (click)="goToPricing()">Back to pricing</button>
          <a class="payment-btn-secondary" href="mailto:manoj@pxlvd.com">Contact support</a>
        </div>
      </ng-container>

      <!-- ── No session ── -->
      <ng-container *ngIf="(verifyStatus$ | async) === 'no_session'">
        <div class="payment-icon error">✕</div>
        <h1 class="payment-title error">Session not found</h1>
        <p class="payment-subtitle">
          We couldn't verify your session. If you were charged, please contact support and we'll sort it out.
        </p>
        <div class="payment-actions">
          <button class="payment-btn-primary" (click)="goToPricing()">Back to pricing</button>
          <a class="payment-btn-secondary" href="mailto:manoj@pxlvd.com">Contact support</a>
        </div>
      </ng-container>

      <!-- ── Error ── -->
      <ng-container *ngIf="(verifyStatus$ | async) === 'error'">
        <div class="payment-icon error">✕</div>
        <h1 class="payment-title error">Something went wrong</h1>
        <p class="payment-subtitle">
          {{ verifyError$ | async }}
        </p>
        <div class="payment-actions">
          <button class="payment-btn-primary" (click)="goToPricing()">Back to pricing</button>
          <a class="payment-btn-secondary" href="mailto:manoj@pxlvd.com">Contact support</a>
        </div>
      </ng-container>

    </div>
  </div>

  <footer class="payment-footer">
    <span>© 2026 pxlvd. Made in Perth, Western Australia.</span>
    <div class="payment-footer-links">
      <a href="/home/privacy-policy">Privacy</a>
      <a href="/home/terms">Terms</a>
      <a href="mailto:manoj@pxlvd.com">Contact</a>
    </div>
  </footer>

</div>
